import {
  Button, Checkbox, Col,
  DatePicker,
  Form,
  Input,
  InputNumber, Row,
  Select,
  Spin,
  Typography
} from 'antd';
import React, { useState } from 'react';
import { debounce } from '../../../../components/Common/Debounce';
import '../../../../components/Common/Form.css';
import { countryList } from "../../../../data/countryList";
import { getLearners } from '../../../../services/learnerService';
import { renderConditionalOptions } from '../../../../utilities/formHelpers';

const { Text } = Typography;

const allLabel = 'All';

const getCountryAmountLabel = (countryName) => `value_${countryName}`;
const getCountryCurrencyLabel = (countryName) => `currency_${countryName}`;

const formValuesToPromoCode = (formValues) => {

  const countryWiseDiscounts = [];
  const countriesNames = formValues.countriesNames;
  if (countriesNames) {
    for (const countryName of countriesNames) {

      if (countryName != allLabel) {
        const amountPropertyName = getCountryAmountLabel(countryName);
        const currencyPropertyName = getCountryCurrencyLabel(countryName);
        const amount = formValues[amountPropertyName];
        const currency = formValues[currencyPropertyName];

        delete formValues[amountPropertyName];
        delete formValues[currencyPropertyName];

        countryWiseDiscounts.push({
          country: countryName,
          value: amount,
          currency: currency,
        });
      }
    }
    delete formValues.countriesNames;
  }
  return {
    ...formValues,
    countryWiseDiscounts: countryWiseDiscounts
  };
};

const promoCodeToFormValues = (promoCode) => {
    const formValues = Object.assign({}, promoCode);
    const countriesNames = [];
    const countryWiseDiscounts = promoCode.countryWiseDiscounts  ?promoCode.countryWiseDiscounts
      .filter(discount => !!discount && discount.country) : [];
    if (countryWiseDiscounts) {
      for (const discount of countryWiseDiscounts) {

        const countryName = discount.country;
        countriesNames.push(countryName);
        const amountPropertyName = getCountryAmountLabel(countryName);
        const currencyPropertyName = getCountryCurrencyLabel(countryName);

        formValues[amountPropertyName] = discount.value;
        formValues[currencyPropertyName] = discount.currency;
      }
    }

    return {
      ...formValues,
      countriesNames: countriesNames
    }
};

const PromoCodeForm = ({
  initialValues,
  onSubmit,
  status,
  type,
  setStatus,
  courses,
  courseOffers,
  maxValue
}) => {
  const [form] = Form.useForm();
  const allOptions = [{ label: allLabel, value: allLabel }];
  const countriesNames = countryList.map(country => ({
    label: country.name,
    value: country.name,
  }));

  const initialFormValues = promoCodeToFormValues(initialValues);
  const [fetching, setFetching] = useState(false);
  const [referrerOptions, setReferrerOptions] = useState([]);
  const [assignedToOptions, setAssignedToOptions] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState(initialFormValues.countriesNames);
  const [maxDiscountPercent, setDiscountMaxPercent] = useState(maxValue);
  const [showRevenueFields, setShowRevenueFields] = useState(false);
  const [hideCorporateFields, setHideCorporateFields] = useState(!initialValues.isCorporate);

  const configurableCountries = selectedCountries
    .filter(countryName => countryName != allLabel);

  const fetchLearnersHandler = debounce((value, type) => {
    setFetching(true);
    getLearners(0, 0, {
      name: value,
      sortBy: 'firstName',
      sortOrder: 'asc',
    })
      .then((response) => {
        const data = response.data.paginatedList.map((learner) => ({
          label: `${learner.firstName} ${learner.lastName} (${learner.email})`,
          value: JSON.stringify(learner),
          fullData: learner,
        }));
        if (type === 'referrer') {
          setReferrerOptions(data);
        } else {
          setAssignedToOptions(data);
        }
        setFetching(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`,
        });
      });
  }, 250);

  const typeChangeHandler = (value) => {
    value === "percent_off" ? setDiscountMaxPercent(100) : setDiscountMaxPercent(Number.MAX_SAFE_INTEGER);
  };
  const handleCodeChange = (e) => {
    form.setFieldsValue({ code: e.target.value.toUpperCase() });
    form.setFieldsValue({ discountType: "amount_off" });
  };

  const revenueSplitSubTypeChangeHandler = (value) => {
    value === "custom" ? setShowRevenueFields(true) : setShowRevenueFields(false);
  };

  const corporateCheckHandler = (value) => {
    const isCorporate = form.getFieldValue("isCorporate");
    if(isCorporate){
      form.setFieldsValue({ discountType: "amount_off" });
    }
    value ? setHideCorporateFields(false) : setHideCorporateFields(true);
    setShowRevenueFields(false)
  };


  const isUpdateForm = () => {
    return type === 'Update';
  };

  const onFinish = (formValues) => {
    const promoCodePayload = formValuesToPromoCode(formValues);
    onSubmit(promoCodePayload);
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 15 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };
  return (
    <div className="course-add-form">
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialFormValues}
      >
        <section>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Code"
                name="code"
                rules={[
                  {
                    required: true,
                    message: 'Please input promo code!',
                  },
                ]}
              >
                <Input onChange={handleCodeChange} disabled={isUpdateForm()} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                label="Promo type"
                name="type"
                rules={[{ required: true }]}
              >
                {/* <Select disabled={isUpdateForm()}> */}
                <Select disabled={true}>
                  {/* <Select.Option value="referral">Referral</Select.Option>
                  <Select.Option value="giftCard">Gift Card</Select.Option> */}
                  <Select.Option value="coupon">Coupon</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
          <Col span={12}>
              <Form.Item
                label="Is Active?"
                name="isActive"
                rules={[{ required: true }]}
              >
                <Select defaultValue={initialValues.isActive}>{renderConditionalOptions()}</Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Is Corporate Promo?"
                name="isCorporate"
                rules={[{ required: true }]}
              >
                <Select onChange={(value) => corporateCheckHandler(value)} defaultValue={initialValues.isCorporate}>{renderConditionalOptions()}</Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                label="Max allowed usage"
                name="maxAllowedUsages"
                rules={[
                  {
                    required: true,
                    message: 'Please input max usage!',
                  },
                ]}
              >
                <InputNumber min={0} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
              label="Max allowed/person"
              name="maxUsagesPerPerson"
              rules={[
                {
                  required: true,
                  message: 'Please input max usage!',
                },
              ]}
            >
              <InputNumber min={0} />
            </Form.Item>
            </Col>
          </Row>

          <Row>  
            <Col span={12}>        
              <Form.Item
                label="Discount type"
                name="discountType"
                rules={[{ required: true }]}
              >
                <Select disabled = {!hideCorporateFields} defaultValue={initialValues.discountType} onChange={(value) => typeChangeHandler(value)}>
                  <Select.Option value="percent_off">Percent</Select.Option>
                  <Select.Option value="amount_off">Amount</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
              label="Discount value"
              name="discountValue"
              rules={[
                {
                  required: true,
                  message: 'Please input discount amount!',
                },
              ]}
            >
              <InputNumber min={0} max={maxDiscountPercent} defaultValue={initialValues.discountValue}/>
            </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                label="Corporate Percent"
                name="corporatePercent"
                hidden = {hideCorporateFields}
                rules={[
                  {
                    required: true,
                    message: 'Please input Corporate Percent!',
                  },
                ]}
              >
                <InputNumber min={0} max={maxDiscountPercent} defaultValue={initialValues.corporatePercent}/>
              </Form.Item>
            </Col>
          </Row>
          
          <Row>
            <Col span={24}>
              <Form.Item hidden = {!hideCorporateFields} label="Referrer/Gifted by" name="referrerId">
                <Select
                  defaultValue={
                    initialValues.metadata?.giftedBy
                      ? initialValues.metadata?.giftedBy?.email
                      : initialValues.metadata?.referrerId
                  }
                  placeholder="Search learners"
                  options={referrerOptions}
                  notFoundContent={fetching ? <Spin size="small" /> : null}
                  filterOption={false}
                  showSearch={true}
                  onSearch={(value) => fetchLearnersHandler(value, 'referrer')}
                  style={{ width: '100%' }}
                  disabled={isUpdateForm()}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item hidden = {!hideCorporateFields} label="Assigned to (gift)" name="assignedTo">
                <Select
                  mode="multiple"
                  placeholder="Search learners"
                  options={assignedToOptions}
                  notFoundContent={fetching ? <Spin size="small" /> : null}
                  filterOption={false}
                  showSearch={true}
                  onSearch={(value) => fetchLearnersHandler(value, 'assignedTo')}
                  style={{ width: '100%' }}
                  name="assignedTo"
                  disabled={isUpdateForm()}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Courses Applicable"
                name="coursesAllowed"
                required={true}
                disabled={isUpdateForm()}
              >
                {courses && courses.length > 0 ? (
                  <Select
                    options={[...allOptions, ...courses]}
                    placeholder={'Select Applied Courses'}
                    mode="multiple"
                    notFoundContent={null}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  />
                ) : null}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Course Offers Applicable"
                name="courseOffersAllowed"
                required={true}
                disabled={isUpdateForm()}
              >
                {courseOffers && courseOffers.length > 0 ? (
                  <Select
                    options={[...allOptions, ...courseOffers]}
                    placeholder={'Select Applied Course Offers'}
                    mode="multiple"
                    notFoundContent={null}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  />
                ) : null}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                label="Is Allowed in all countries?"
                name="allowInAllCountries"
                rules={[{ required: true }]}
              >
                <Select defaultValue={initialValues.allowInAllCountries}>{renderConditionalOptions()}</Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Countries"
                name="countriesNames"
                required={true}
                disabled={isUpdateForm()}
              >
                <Select
                  name="countriesNames"
                  options={[...allOptions, ...countriesNames]}
                  placeholder={'Select Countries'}
                  mode="multiple"
                  notFoundContent={null}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={setSelectedCountries}
                />

              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {configurableCountries.map(countryName => (
                <Form.Item label={countryName}>
                  <Form.Item name={getCountryAmountLabel(countryName)} required={true}
                            style={{ display: 'inline-block', width: 'calc(50% - 8px)', marginBottom: 0 }}>
                    <InputNumber min={0} placeholder="Amount"/>
                  </Form.Item>
                  <Form.Item name={getCountryCurrencyLabel(countryName)} required={true}
                            style={{ display: 'inline-block', width: 'calc(50% - 8px)', marginLeft: '8px',  marginBottom: 0 }}>
                    <Input placeholder="Currency"></Input>
                  </Form.Item>

                </Form.Item>
              ))}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Revenue Split Type"
                name="revenueSplitType"
                rules={[{ required: true }]}
              >
                <Select
                  defaultValue={initialValues.revenueSplitType}
                >
                  <Select.Option value="academy_funded">Nas Academy Funded</Select.Option>
                  <Select.Option value="creator_funded">Creator Funded</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Nas Academy Revenue Share Type"
                name="revenueSplitSubType"
              >
                <Select
                  defaultValue={initialValues.revenueSplitSubType}
                  onChange={(value) => revenueSplitSubTypeChangeHandler(value)}
                >
                  <Select.Option value="custom">Custom Percent</Select.Option>
                  <Select.Option value="default">Default</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Nas Academy Revenue Share Value"
                name="academyRevenueShareValue"
                hidden = {!showRevenueFields}
              >
                <InputNumber min={0} max={100} defaultValue={initialValues.academyRevenueShareValue} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item
                label="Start Date"
                name="startDate"
                rules={[
                  { required: true, message: 'Please input valid start date' },
                ]}
              >
                <DatePicker
                  showTime={true}
                  showNow={false}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="End Date"
                name="endDate"
                rules={[
                  { required: true, message: 'Please input valid end date!' },
                ]}
              >
                <DatePicker
                  showTime={true}
                  showNow={false}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                name="excludeEnrolment"
                valuePropName="checked"
              >
                <Checkbox
                checked={initialFormValues.excludeEnrolment}
              >
                Exclude from Enrolment Count
              </Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </section>

        {status.type === 'ERROR' ? (
          <Text type="danger">{status.message}</Text>
        ) : null}
        {status.type === 'SUCCESS' ? (
          <Text type="success">Successful!</Text>
        ) : null}
        <br />

        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default PromoCodeForm;
